<div class="item">
  @if (ItemType == 'TEXT') {
    <div>
      <app-lesson-content-item-text #item [ItemUid]="ItemUid" [ItemData]="ItemData||''" [IsSelected]="IsSelected"
      (OnChanged)="onChanged($event)"></app-lesson-content-item-text>
    </div>
  }

  @if (ItemType == 'IMAGE') {
    <div>
      <app-lesson-content-item-image #item [ItemUid]="ItemUid" [ItemData]="ItemData" [IsSelected]="IsSelected"
      [Scale]="scale" (OnChanged)="onChanged($event)"></app-lesson-content-item-image>
    </div>
  }

  @if (ItemType == 'FILE') {
    <div>
      <app-lesson-content-item-file #item
        [ItemUid]="ItemUid"
        [ItemData]="ItemData"
        [IsSelected]="IsSelected"
        (OnChangedFile)="onChangedFile($event)"
        [buttonName]="buttonName"
      ></app-lesson-content-item-file>
    </div>
  }

  @if (ItemType == 'VIDEO') {
    <div>
      <app-lesson-content-item-video #item [ItemUid]="ItemUid" [ItemData]="ItemData" [IsSelected]="IsSelected"
      (OnChanged)="onChanged($event)"></app-lesson-content-item-video>
    </div>
  }

  @if (ItemType == 'AUDIO') {
    <div>
      <app-lesson-content-item-audio #item
        [ItemUid]="ItemUid"
        [ItemData]="ItemData"
        [IsSelected]="IsSelected"
        [buttonName]="buttonName"
        (OnChangedFile)="onChangedFile($event)">
      </app-lesson-content-item-audio>
    </div>
  }

  @if (ItemType == 'PARTNER') {
    <div>
      <app-lesson-content-item-partner #item
        [ItemUid]="ItemUid"
        [ItemData]="ItemData"
        [IsSelected]="IsSelected"
        [EditMode]="EditMode"
        (OnChanged)="onChanged($event)">
      </app-lesson-content-item-partner>
    </div>
  }

  @if (ItemType == 'IFRAME') {
    <div>
      <app-lesson-content-item-iframe #item
        [ItemUid]="ItemUid"
        [ItemData]="ItemData"
        [IsSelected]="IsSelected"
        [EditMode]="EditMode"
        (OnChanged)="onChanged($event)">
      </app-lesson-content-item-iframe>
    </div>
  }

  @defer (on viewport) {
  @if (ItemType == 'VIDEO_STREAM') {
    <div>
      <app-lesson-content-item-videostream #item
        [ItemUid]="ItemUid"
        [ItemData]="ItemData"
        [IsSelected]="IsSelected"
        (OnChangedFile)="onChangedFile($event)"
        >
      </app-lesson-content-item-videostream>
    </div>
  }
}
@placeholder {
<span>Загрузка...</span>
}



</div>
